
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Thompson',
      vehicle: '2022 BMW M5',
      rating: 5,
      text: 'The Auto Salon transformed my car. The ceramic coating is incredible—water just beads right off. Professional service from start to finish.',
    },
    {
      name: 'Sarah Martinez',
      vehicle: '2020 Audi Q7',
      rating: 5,
      // Escaped apostrophe to avoid syntax error
      text: 'Best detailing experience I\'ve ever had. They took care of every little detail and my SUV looks brand new. Highly recommend!',
    },
    {
      name: 'James Wilson',
      vehicle: '2019 Mercedes-Benz C-Class',
      rating: 5,
      text: 'Outstanding paint correction work. They removed years of swirl marks and scratches. My car has never looked this good.',
    },
    {
      name: 'Emily Rodriguez',
      vehicle: '2021 Tesla Model 3',
      rating: 5,
      text: 'Professional, reliable, and meticulous. The interior deep clean was thorough and the exterior looks showroom fresh. Worth every penny.',
    },
    {
      name: 'David Chen',
      vehicle: '2018 Porsche 911',
      rating: 5,
      text: 'I trust The Auto Salon with my weekend car. Their attention to detail and quality products give me peace of mind. Always excellent results.',
    },
    {
      name: 'Amanda Foster',
      vehicle: '2023 Range Rover Sport',
      rating: 5,
      text: 'From the first call to final pickup, everything was seamless. The reconditioning package exceeded my expectations. Five stars!',
    },
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            What Our Clients Say
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto px-4">
            Real feedback from real car owners who trust us with their vehicles.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#00D9FF] text-lg sm:text-xl"></i>
                ))}
              </div>
              <p className="text-sm sm:text-base text-gray-700 mb-6 leading-relaxed">{testimonial.text}</p>
              <div className="border-t border-gray-200 pt-4">
                <div className="font-bold text-base sm:text-lg text-gray-900">{testimonial.name}</div>
                <div className="text-xs sm:text-sm text-gray-600">{testimonial.vehicle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
